export const header = () => {
  let lastScrollTop = 0;
  const nav = document.querySelector('header');
  let navHeight = nav.offsetHeight;

  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > (navHeight * 2)) {
      if (scrollTop > lastScrollTop) {
        nav.classList.add('header-hidden');
      } else {
        nav.classList.remove('header-hidden'); 
      }
    } else {
      nav.classList.remove('header-hidden');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; 
  });

  window.addEventListener('resize', () => {
    navHeight = nav.offsetHeight;
  });
}